import { render, staticRenderFns } from "./PcViewer.vue?vue&type=template&id=175f4881&"
import script from "./PcViewer.vue?vue&type=script&lang=js&"
export * from "./PcViewer.vue?vue&type=script&lang=js&"
import style0 from "./PcViewer.vue?vue&type=style&index=0&id=175f4881&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports